
import { defineComponent } from 'vue';
import Chat from '../Components/Chat/Chat.vue';

export default defineComponent({
  components: {
    Chat,
  },
  props: {
    aiName: {
      type: String,
      required: true,
    },
    aiLabel: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
    apiMethod: {
      type: String,
      required: true,
    },
  },
});
